/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Bullet_Move_DownInputs */



/**
* | output |
* | --- |
* | "Move bullet down" |
*
* @param {Presentation_Bullet_Move_DownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_bullet_move_down = /** @type {((inputs?: Presentation_Bullet_Move_DownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Bullet_Move_DownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufzählungspunkt nach unten")
	return /** @type {LocalizedString} */ ("Move bullet down")
});